/* ==========================================================================
   NGA — Shop interactions
   Quick add · swatch + size selection · look builder · compare slider ·
   club channel · cart count sync
   ========================================================================== */
(function () {
  'use strict';

  // Several sections include this file, so it can be requested more than once
  // on a page. Its listeners are delegated on document, and registering them
  // twice made every click fire twice — a size button selected and then
  // immediately deselected itself.
  if (window.__ngaShopLoaded) return;
  window.__ngaShopLoaded = true;

  var NGA = (window.NGA = window.NGA || {});
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function money(cents) {
    if (cents == null) return '';
    var n = Number(cents);
    if (isNaN(n)) return '';
    if (window.Shopify && window.Shopify.formatMoney && window.NGA_MONEY_FORMAT) {
      try { return window.Shopify.formatMoney(n, window.NGA_MONEY_FORMAT); } catch (e) {}
    }
    return '$' + (n / 100).toFixed(2).replace(/\.00$/, '');
  }

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---------------------------------------------------------------------
     Cart
     --------------------------------------------------------------------- */
  function addToCart(items) {
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw new Error((body && (body.description || body.message)) || 'Could not add to bag');
        return body;
      });
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bubble = document.querySelector('#cart-icon-bubble .nga-header__count');
        if (!bubble) return;
        bubble.textContent = cart.item_count;
        bubble.hidden = cart.item_count === 0;
        bubble.classList.remove('is-bump');
        void bubble.offsetWidth;
        bubble.classList.add('is-bump');
      })
      .catch(function () { /* count is cosmetic */ });
  }

  NGA.addToCart = addToCart;
  NGA.refreshCartCount = refreshCartCount;
  document.addEventListener('nga:cart:updated', refreshCartCount);

  /* ---------------------------------------------------------------------
     Editorial product card
     --------------------------------------------------------------------- */
  function cardState(card) {
    if (card.__nga) return card.__nga;
    var variants = parseJSON(card.querySelector('[data-nga-ecard-variants]')) || [];
    var config = parseJSON(card.querySelector('[data-nga-ecard-config]')) || { sizeIndex: -1, colorIndex: -1 };
    card.__nga = { variants: variants, config: config, size: null, color: null };

    // Default the colour to the first swatch so a size click can resolve.
    var firstSwatch = card.querySelector('[data-nga-ecard-swatch]');
    if (firstSwatch) card.__nga.color = firstSwatch.getAttribute('data-nga-ecard-swatch');

    return card.__nga;
  }

  function resolveVariant(card) {
    var st = cardState(card);
    var si = st.config.sizeIndex;
    var ci = st.config.colorIndex;

    var match = st.variants.filter(function (v) {
      if (si > -1 && st.size != null && v.options[si] !== st.size) return false;
      if (ci > -1 && st.color != null && v.options[ci] !== st.color) return false;
      return true;
    });

    // Prefer something actually purchasable.
    var available = match.filter(function (v) { return v.available; });
    return available[0] || match[0] || null;
  }

  function paintCard(card) {
    var st = cardState(card);
    var v = resolveVariant(card);
    var priceEl = card.querySelector('[data-nga-ecard-price]');
    var mainImg = card.querySelector('[data-nga-ecard-main]');

    if (v && priceEl) {
      var html = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) html += '<s>' + money(v.compare_at_price) + '</s>';
      priceEl.innerHTML = html;
    }
    if (v && v.image && mainImg && st.color != null) mainImg.src = v.image;

    // Grey out sizes that do not exist in the chosen colour.
    if (st.config.sizeIndex > -1) {
      card.querySelectorAll('[data-nga-ecard-size]').forEach(function (btn) {
        var val = btn.getAttribute('data-nga-ecard-size');
        var possible = st.variants.some(function (vv) {
          if (vv.options[st.config.sizeIndex] !== val) return false;
          if (st.config.colorIndex > -1 && st.color != null && vv.options[st.config.colorIndex] !== st.color) return false;
          return vv.available;
        });
        btn.disabled = !possible;
        btn.setAttribute('aria-disabled', possible ? 'false' : 'true');
      });
    }
  }

  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('[data-nga-ecard-size]');
    if (sizeBtn && !sizeBtn.disabled) {
      e.preventDefault();
      var card = sizeBtn.closest('[data-nga-ecard]');
      var st = cardState(card);
      var val = sizeBtn.getAttribute('data-nga-ecard-size');
      var already = sizeBtn.classList.contains('is-active');
      card.querySelectorAll('[data-nga-ecard-size]').forEach(function (b) { b.classList.remove('is-active'); });
      st.size = already ? null : val;
      if (!already) sizeBtn.classList.add('is-active');
      paintCard(card);
      return;
    }

    var swatch = e.target.closest('[data-nga-ecard-swatch]');
    if (swatch) {
      e.preventDefault();
      var scard = swatch.closest('[data-nga-ecard]');
      var sst = cardState(scard);
      scard.querySelectorAll('[data-nga-ecard-swatch]').forEach(function (b) { b.classList.remove('is-active'); });
      swatch.classList.add('is-active');
      sst.color = swatch.getAttribute('data-nga-ecard-swatch');
      paintCard(scard);
      return;
    }

    var quick = e.target.closest('[data-nga-quick-add]');
    if (quick && !quick.disabled) {
      e.preventDefault();
      var qcard = quick.closest('[data-nga-ecard]');
      var qst = cardState(qcard);

      // If the product has sizes and none is chosen, ask for one rather than
      // silently adding an arbitrary variant.
      if (qst.config.sizeIndex > -1 && qst.size == null) {
        var sizes = qcard.querySelector('.nga-ecard__sizes');
        if (sizes) {
          sizes.animate(
            [{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }],
            { duration: 300, easing: 'ease-in-out' }
          );
        }
        if (NGA.toast) NGA.toast(quick.getAttribute('data-choose-label') || 'Choose a size first.');
        return;
      }

      var variant = resolveVariant(qcard);
      if (!variant || !variant.available) {
        if (NGA.toast) NGA.toast('That option is sold out.');
        return;
      }

      var label = quick.getAttribute('data-label') || quick.textContent;
      var addedLabel = quick.getAttribute('data-added-label') || 'Added';
      quick.disabled = true;
      quick.textContent = '…';

      addToCart([{ id: variant.id, quantity: 1 }])
        .then(function () {
          quick.textContent = addedLabel;
          quick.classList.add('is-added');
          refreshCartCount();
          // nga-cart.js listens for this: it refreshes the drawer's contents
          // and opens it. Quick add was never firing it, which is why the
          // drawer stayed shut after a successful add.
          document.dispatchEvent(new CustomEvent('nga:cart:added', { detail: { id: variant.id } }));
          setTimeout(function () {
            quick.textContent = label;
            quick.classList.remove('is-added');
            quick.disabled = false;
          }, 1800);
        })
        .catch(function (err) {
          quick.textContent = label;
          quick.disabled = false;
          if (NGA.toast) NGA.toast(err.message || 'Could not add to bag.');
        });
    }
  });

  /* ---------------------------------------------------------------------
     Build the look
     --------------------------------------------------------------------- */
  function initLook(root) {
    (root || document).querySelectorAll('[data-nga-look]:not([data-nga-look-done])').forEach(function (look) {
      look.setAttribute('data-nga-look-done', '');

      var totalEl = look.querySelector('[data-nga-look-total]');
      var saveEl = look.querySelector('[data-nga-look-save]');
      var addBtn = look.querySelector('[data-nga-look-add]');
      var discount = parseFloat(look.getAttribute('data-discount')) || 0;

      function items() {
        return Array.prototype.slice.call(look.querySelectorAll('[data-nga-look-item]'))
          .filter(function (i) { return !i.classList.contains('is-removed'); });
      }

      function recalc() {
        var total = 0;
        items().forEach(function (item) {
          var sel = item.querySelector('[data-nga-look-select]');
          var price = sel
            ? Number(sel.options[sel.selectedIndex].getAttribute('data-price'))
            : Number(item.getAttribute('data-price'));
          if (!isNaN(price)) total += price;
          var priceEl = item.querySelector('[data-nga-look-price]');
          if (priceEl && !isNaN(price)) priceEl.textContent = money(price);
        });

        var payable = discount > 0 ? Math.round(total * (1 - discount / 100)) : total;
        if (totalEl) totalEl.textContent = money(payable);
        if (saveEl) {
          if (discount > 0 && total > 0) {
            saveEl.textContent = saveEl.getAttribute('data-prefix') + ' ' + money(total - payable);
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }
        if (addBtn) addBtn.disabled = items().length === 0;
      }

      look.addEventListener('change', function (e) {
        if (e.target.closest('[data-nga-look-select]')) recalc();
      });

      look.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-nga-look-remove]');
        if (rm) {
          e.preventDefault();
          var item = rm.closest('[data-nga-look-item]');
          var removed = item.classList.toggle('is-removed');
          rm.setAttribute('aria-label', removed ? 'Add back to the look' : 'Remove from the look');
          var sel = item.querySelector('[data-nga-look-select]');
          if (sel) sel.disabled = removed;
          recalc();
          return;
        }

        if (e.target.closest('[data-nga-look-add]')) {
          e.preventDefault();
          var payload = [];
          items().forEach(function (item) {
            var sel = item.querySelector('[data-nga-look-select]');
            var id = sel ? sel.value : item.getAttribute('data-variant-id');
            if (id) payload.push({ id: Number(id), quantity: 1 });
          });
          if (!payload.length) return;

          var original = addBtn.textContent;
          addBtn.disabled = true;
          addBtn.textContent = '…';

          addToCart(payload)
            .then(function () {
              addBtn.textContent = addBtn.getAttribute('data-added-label') || 'Added';
              refreshCartCount();
              if (NGA.toast) NGA.toast('The look is in your bag. <a href="/cart">View bag</a>', { variant: 'pink' });
              setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 2000);
            })
            .catch(function (err) {
              addBtn.textContent = original;
              addBtn.disabled = false;
              if (NGA.toast) NGA.toast(err.message || 'Could not add the look.');
            });
        }
      });

      recalc();
    });
  }

  /* ---------------------------------------------------------------------
     Before / after compare slider
     --------------------------------------------------------------------- */
  function initCompare(root) {
    (root || document).querySelectorAll('[data-nga-compare]:not([data-nga-compare-done])').forEach(function (el) {
      el.setAttribute('data-nga-compare-done', '');
      var handle = el.querySelector('[data-nga-compare-handle]');
      var dragging = false;

      function setPct(pct) {
        pct = Math.max(0, Math.min(100, pct));
        el.style.setProperty('--nga-compare', pct + '%');
        if (handle) handle.setAttribute('aria-valuenow', Math.round(pct));
      }

      function fromEvent(e) {
        var rect = el.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        setPct((x / rect.width) * 100);
      }

      function start(e) { dragging = true; fromEvent(e); }
      function move(e) { if (dragging) { fromEvent(e); if (e.cancelable) e.preventDefault(); } }
      function end() { dragging = false; }

      el.addEventListener('mousedown', start);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', end);
      el.addEventListener('touchstart', start, { passive: true });
      window.addEventListener('touchmove', move, { passive: false });
      window.addEventListener('touchend', end);
      el.addEventListener('click', function (e) { if (!e.target.closest('[data-nga-compare-handle]')) fromEvent(e); });

      if (handle) {
        handle.addEventListener('keydown', function (e) {
          var cur = parseFloat(getComputedStyle(el).getPropertyValue('--nga-compare')) || 50;
          if (e.key === 'ArrowLeft') { e.preventDefault(); setPct(cur - 4); }
          if (e.key === 'ArrowRight') { e.preventDefault(); setPct(cur + 4); }
          if (e.key === 'Home') { e.preventDefault(); setPct(0); }
          if (e.key === 'End') { e.preventDefault(); setPct(100); }
        });
      }

      setPct(parseFloat(el.getAttribute('data-start')) || 50);
    });
  }

  /* ---------------------------------------------------------------------
     Club channel
     --------------------------------------------------------------------- */
  function initChannel(root) {
    (root || document).querySelectorAll('[data-nga-channel]:not([data-nga-channel-done])').forEach(function (ch) {
      ch.setAttribute('data-nga-channel-done', '');

      var feature = ch.querySelector('[data-nga-channel-feature]');
      var video = feature && feature.querySelector('video');
      var poster = feature && feature.querySelector('img');
      var capEl = ch.querySelector('[data-nga-channel-caption]');
      var shopWrap = ch.querySelector('[data-nga-channel-shop]');
      var thumbs = Array.prototype.slice.call(ch.querySelectorAll('[data-nga-channel-thumb]'));
      var playBtn = ch.querySelector('[data-nga-channel-play]');

      function select(thumb) {
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });

        var src = thumb.getAttribute('data-video-src');
        var img = thumb.getAttribute('data-poster');
        var cap = thumb.getAttribute('data-caption') || '';
        var shopHtml = thumb.getAttribute('data-shop') || '';

        if (poster && img) poster.src = img;
        if (video) {
          video.pause();
          feature.classList.remove('is-playing');
          if (src) {
            video.src = src;
            if (img) video.poster = img;
            video.load();
          } else {
            video.removeAttribute('src');
            video.load();
          }
        }
        if (capEl) { capEl.textContent = cap; capEl.hidden = !cap; }
        if (shopWrap) {
          shopWrap.innerHTML = shopHtml;
          shopWrap.hidden = !shopHtml;
        }
      }

      thumbs.forEach(function (t) { t.addEventListener('click', function () { select(t); }); });

      if (playBtn && video) {
        playBtn.addEventListener('click', function () {
          if (video.paused) {
            video.muted = false;
            var p = video.play();
            if (p && p.catch) p.catch(function () { video.muted = true; video.play(); });
            feature.classList.add('is-playing');
          } else {
            video.pause();
            feature.classList.remove('is-playing');
          }
        });
        video.addEventListener('pause', function () { feature.classList.remove('is-playing'); });
        video.addEventListener('play', function () { feature.classList.add('is-playing'); });
      }

      if (thumbs.length) select(thumbs[0]);
    });
  }

  /* ---------------------------------------------------------------------
     Boot
     --------------------------------------------------------------------- */
  function boot(root) {
    initLook(root);
    initCompare(root);
    initChannel(root);
    (root || document).querySelectorAll('[data-nga-ecard]').forEach(function (c) { paintCard(c); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('nga:refresh', function (e) { boot((e.detail && e.detail.root) || document); });
})();
